import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CustomRenderer, DecimalRenderer } from './numeralRenderers';

class ValidationSummaryHeader extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    validationSummary: PropTypes.shape({
      importResults: PropTypes.string.isRequired,
      importStatus: PropTypes.number.isRequired,
      trialTotal: PropTypes.number.isRequired,
    }),
    entityName: PropTypes.string.isRequired,
    additionalComponent: PropTypes.node,
    shouldDisplayZero: PropTypes.bool,
  };

  render() {
    const {
      className,
      validationSummary,
      entityName,
      additionalComponent,
      shouldDisplayZero,
    } = this.props;

    const balancesTotalValue = (validationSummary && validationSummary.trialTotal) ? validationSummary.trialTotal : 0;

    return (
      <div className={classnames('row', className)}>
        <div
          className={classnames('col-4', {
            'text-danger': validationSummary && (
              validationSummary.trialTotal >= 1 || validationSummary.trialTotal <= -1
            ),
          })}
        >
          <span>Balances Total: </span>
          {
            shouldDisplayZero
              ? <DecimalRenderer value={balancesTotalValue} />
              : <CustomRenderer value={balancesTotalValue} />
          }
        </div>
        <div
          className={classnames(
            'col-6',
            { 'text-danger': validationSummary && validationSummary.importStatus === -1 }
          )}
        >
          {
            validationSummary && validationSummary.importStatus === -1
              ? <span>{entityName} load <strong>error</strong>. </span>
              : <span>{entityName} load complete. </span>
          }
          <span>{validationSummary ? validationSummary.importResults : null}</span>
        </div>
        {additionalComponent}
      </div>
    );
  }
}

export default ValidationSummaryHeader;
